/**
 * Les adresses des pages publiques (chantier comptes, ticket 05). App les reconnaît avant de
 * regarder la session : elles se lisent connecté ou non. Testé dans tests/client/comptes/pagesPubliques.test.ts.
 */

export const CHEMINS_PUBLICS = ['/confidentialite', '/mentions-legales'] as const;

export type CheminPublic = (typeof CHEMINS_PUBLICS)[number];

/** La page publique de ce chemin, ou null. Une barre finale est tolérée, rien d'autre. */
export function pagePubliqueDe(chemin: string): CheminPublic | null {
  const net = chemin.length > 1 ? chemin.replace(/\/+$/, '') : chemin;
  return (CHEMINS_PUBLICS as readonly string[]).includes(net) ? (net as CheminPublic) : null;
}
